import { StateBlock as StateBlockBase } from '@pulse-web-ui/state-block';
import { styled } from '@pulse-web-ui/theme';

export const StateBlock = styled(StateBlockBase)`
  max-width: 536px;
  & h1 {
    margin-bottom: 16px;
  }
`;
